export default {
  subscription: 'Подписка',
  subscriptions: 'Подписки',
  'subscription.feature': 'Функция',
  'subscription.features': 'Функции',
  'subscription.select': 'Выбрать',
  'subscription.selected': 'Выбрано',
  'subscription.title': 'Название',
  'subscription.duration': 'Период оплаты',
  'subscription.sale': 'Информация о распродаже',
  'subscription.saleStart': 'Начало',
  'subscription.saleEnd': 'Окончание',
  'subscription.discount': 'Скидка',
  'subscription.discountInfo': 'Скидка {discount}',
  'subscription.info': 'Информация о подписке',
  'subscription.price': 'Цена',
  'subscription.notice': 'Уведомление',
  'subscription.users': 'Максимум бизнес-пользователей',
  'subscription.usersInfo': 'До {{users}} пользователей',
  'subscription.actions.edit': 'Редактировать подписки',
  'subscription.actions.addNew': 'Добавить новую подписку',
  'subscription.actions.manage': 'Управление подписками',
  'subscription.msg.deleteConfirm':
    'Вы уверены, что хотите удалить эту подписку',
  'subscription.tags': 'Теги',
  'subscription.assigned.features': 'Назначенные функции ({{count}})',
  'subscription.features.helper':
    'Для создания подписки нужно назначить хотя бы одну функцию. Функции определяют возможности подписки. Выберите функции из списка или создайте новые.',
  'subscription.msg.unAssignConfirm':
    'Вы уверены, что хотите снять назначение этой функции?',
  'subscription.msg.unAssignAllConfirm':
    'Вы уверены, что хотите снять назначение со всех функций?',
  'subscription.msg.deactivateBlocked': 'Деактивация заблокирована',
  'subscription.msg.deactivateBlockedDescription':
    'Невозможно деактивировать эту подписку, так как она используется для {{tenantName}}.',
  'subscription.actions.navigateToTenant': 'Перейти к арендатору',
};
